import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AddServiceDeploymentTaskLocationFilterActions } from '../../../actions/servicedeployment.constants';

@Injectable()
export class AddServicedeploymentTaskLocationReduxService {
  constructor() {}

  public setFilter(filter: object) {
    this._setFilter(filter);
  }

  @dispatch()
  private _setFilter = (filter: object) => ({
    type: AddServiceDeploymentTaskLocationFilterActions.SetFilter,
    payload: filter,
  });
}
